<template lang='pug'>
  div
    span(v-if='type === "interval"')
      strong {{interval}}
    span(v-if='type === "detect"')
      strong {{detect}}
    span(v-if='delay') &nbsp; after
      strong &nbsp;{{delay}}&nbsp;
      | seconds

</template>

<script>
import {get} from 'lodash';

export default {
  name: 'RunConfigurationTarget',
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    type() {
      return this.config.type;
    },
    interval() {
      if (this.type !== 'interval') return null;
      const interval = get(this.config, 'target.interval');
      if (interval === '20minutes') return 'Every 20 Minutes';
      if (interval === '1hour') return 'Every Hour';
      if (interval === '2hours') return 'Every 2 Hours';
      if (interval === '4hours') return 'Every 4 Hours';
      if (interval === '8hours') return 'Every 8 Hours';
      if (interval === '12hours') return 'Every 12 Hours';
      if (interval === '1day') return 'Every Day';
      if (interval === '2days') return 'Every 2 Days';
      if (interval === '1week') return 'Every Week';
      return null;
    },
    detect() {
      if (this.type !== 'detect') return null;
      return this.config.target.url;
    },
    delay() {
      return get(this.config, 'target.delaySeconds');
    }
  }
};
</script>

<style scoped>

</style>
